var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4133",
    "data-name": "Group 4133",
    transform: "translate(-446.25 -244)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6720",
    "data-name": "Rectangle 6720",
    width: 30,
    height: 30,
    rx: 5,
    transform: "translate(446.25 244)",
    fill: "#deefee"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-eye-3565397",
    transform: "translate(300.564 91.512)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32606",
    "data-name": "Path 32606",
    d: "M160.685,164.261a7.808,7.808,0,0,0-6.15,3.01.329.329,0,0,0,0,.433,7.788,7.788,0,0,0,12.3,0,.329.329,0,0,0,0-.433A7.808,7.808,0,0,0,160.685,164.261Zm-7.168,2.209a9.077,9.077,0,0,1,14.335,0,1.628,1.628,0,0,1,0,2.036,9.077,9.077,0,0,1-14.335,0A1.628,1.628,0,0,1,153.517,166.47Zm7.168-.282a1.3,1.3,0,1,0,1.3,1.3A1.318,1.318,0,0,0,160.685,166.188Zm-2.577,1.3a2.577,2.577,0,1,1,2.577,2.577A2.569,2.569,0,0,1,158.108,167.488Z",
    transform: "translate(0)",
    stroke: "#00685F",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.cf1729d280b497987aefd19c4ccdef72.svg";
export { ForwardRef as ReactComponent };